import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertInfoService } from './alert-info.service';

@Component({
  selector: 'lib-alert-info',
  templateUrl: './alert-info.component.html',
  styleUrls: ['./alert-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertInfoComponent implements OnInit {
  showAlertMessage$: Observable<boolean>;

  constructor(private alertInfoService: AlertInfoService) {}

  ngOnInit() {
    this.showAlertMessage$ = this.alertInfoService.showAlertMessage();
  }
}
